import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { MaterialGraphExtendedRevisionFragmentDoc, MaterialGraphRevisionFragmentDoc } from '../material-graph/material-graph.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DataObjectDetailsForNameAssetFromSchemaServiceFragment = { __typename: 'DataObject', id: string, mediaType?: string | null, objectName: string, related?: Array<{ __typename: 'DataObject', id: string, mediaType?: string | null, objectName: string, originalFileName: string }> };

export type MaterialDetailsForNameAssetFromSchemaServiceFragment = { __typename: 'Material', id: string, legacyId: number, articleId?: string | null, name?: string | null, dataObjectAssignments: Array<{ __typename: 'DataObjectAssignment', assignmentType: Types.DataObjectAssignmentType, dataObject: { __typename: 'DataObject', id: string, mediaType?: string | null, objectName: string, related?: Array<{ __typename: 'DataObject', id: string, mediaType?: string | null, objectName: string, originalFileName: string }> } }>, organization?: { __typename: 'Organization', id: string, name?: string | null } | null, tagAssignments: Array<{ __typename: 'TagAssignment', tag: { __typename: 'Tag', name: string, type: Types.TagType, otherInfo?: string | null } }>, latestCyclesRevision?: { __typename: 'MaterialRevision', number: number, graphNode: any, id: string, legacyId: number, material: { __typename: 'Material', name?: string | null, legacyId: number } } | null, outputs: Array<{ __typename: 'MaterialOutput', type: Types.MaterialOutputType, config?: { __typename: 'JsonFile', content: any } | null, result?: { __typename: 'DataObject', id: string } | null }> };

export type MaterialForNameAssetFromSchemaServiceQueryVariables = Types.Exact<{
  materialId: Types.Scalars['ID']['input'];
  dataObjectAssignmentFilter?: Types.InputMaybe<Types.DataObjectAssignmentFilterInput>;
  includeRelated: Types.Scalars['Boolean']['input'];
}>;


export type MaterialForNameAssetFromSchemaServiceQuery = { __typename: 'Query', material: { __typename: 'Material', id: string, legacyId: number, articleId?: string | null, name?: string | null, dataObjectAssignments: Array<{ __typename: 'DataObjectAssignment', assignmentType: Types.DataObjectAssignmentType, dataObject: { __typename: 'DataObject', id: string, mediaType?: string | null, objectName: string, related?: Array<{ __typename: 'DataObject', id: string, mediaType?: string | null, objectName: string, originalFileName: string }> } }>, organization?: { __typename: 'Organization', id: string, name?: string | null } | null, tagAssignments: Array<{ __typename: 'TagAssignment', tag: { __typename: 'Tag', name: string, type: Types.TagType, otherInfo?: string | null } }>, latestCyclesRevision?: { __typename: 'MaterialRevision', number: number, graphNode: any, id: string, legacyId: number, material: { __typename: 'Material', name?: string | null, legacyId: number } } | null, outputs: Array<{ __typename: 'MaterialOutput', type: Types.MaterialOutputType, config?: { __typename: 'JsonFile', content: any } | null, result?: { __typename: 'DataObject', id: string } | null }> } };

export type NameAssetFromSchemaUpdateDataObjectMutationVariables = Types.Exact<{
  input: Types.MutationUpdateDataObjectInput;
  includeRelated?: Types.Scalars['Boolean']['input'];
}>;


export type NameAssetFromSchemaUpdateDataObjectMutation = { __typename: 'Mutation', updateDataObject: { __typename: 'DataObject', id: string, mediaType?: string | null, objectName: string, related?: Array<{ __typename: 'DataObject', id: string, mediaType?: string | null, objectName: string, originalFileName: string }> } };

export const DataObjectDetailsForNameAssetFromSchemaServiceFragmentDoc = gql`
    fragment DataObjectDetailsForNameAssetFromSchemaService on DataObject {
  id
  mediaType
  objectName
  related @include(if: $includeRelated) {
    id
    mediaType
    objectName
    originalFileName
  }
}
    `;
export const MaterialDetailsForNameAssetFromSchemaServiceFragmentDoc = gql`
    fragment MaterialDetailsForNameAssetFromSchemaService on Material {
  id
  legacyId
  articleId
  dataObjectAssignments(filter: $dataObjectAssignmentFilter) {
    assignmentType
    dataObject {
      ...DataObjectDetailsForNameAssetFromSchemaService
    }
  }
  name
  organization {
    id
    name
  }
  tagAssignments {
    tag {
      name
      type
      otherInfo
    }
  }
  latestCyclesRevision {
    number
    ...MaterialGraphExtendedRevision
    graphNode
  }
  outputs {
    type
    config {
      content
    }
    result {
      id
    }
  }
}
    `;
export const MaterialForNameAssetFromSchemaServiceDocument = gql`
    query materialForNameAssetFromSchemaService($materialId: ID!, $dataObjectAssignmentFilter: DataObjectAssignmentFilterInput, $includeRelated: Boolean!) {
  material(id: $materialId) {
    ...MaterialDetailsForNameAssetFromSchemaService
  }
}
    ${MaterialDetailsForNameAssetFromSchemaServiceFragmentDoc}
${DataObjectDetailsForNameAssetFromSchemaServiceFragmentDoc}
${MaterialGraphExtendedRevisionFragmentDoc}
${MaterialGraphRevisionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MaterialForNameAssetFromSchemaServiceGQL extends Apollo.Query<MaterialForNameAssetFromSchemaServiceQuery, MaterialForNameAssetFromSchemaServiceQueryVariables> {
    override document = MaterialForNameAssetFromSchemaServiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NameAssetFromSchemaUpdateDataObjectDocument = gql`
    mutation nameAssetFromSchemaUpdateDataObject($input: MutationUpdateDataObjectInput!, $includeRelated: Boolean! = false) {
  updateDataObject(input: $input) {
    ...DataObjectDetailsForNameAssetFromSchemaService
  }
}
    ${DataObjectDetailsForNameAssetFromSchemaServiceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class NameAssetFromSchemaUpdateDataObjectGQL extends Apollo.Mutation<NameAssetFromSchemaUpdateDataObjectMutation, NameAssetFromSchemaUpdateDataObjectMutationVariables> {
    override document = NameAssetFromSchemaUpdateDataObjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }